// src/components/statusPill/index.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { STATUS_META } from '../../constants/wizard';
import './index.scss';

const StatusPill = ({ status, size = 'md' }) => {
  const meta = STATUS_META[status] ?? { label: status, tone: 'neutral' };

  return (
    <span className={`status-pill status-pill--${meta.tone} status-pill--${size}`}>
      <span className="status-pill__dot" aria-hidden="true" />
      {meta.label}
    </span>
  );
};

StatusPill.propTypes = {
  status: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['sm', 'md'])
};

export default StatusPill;
